import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import store from "./app/store";
import { BrowserRouter as Router } from 'react-router-dom'

import App from './app/App';
import reportWebVitals from './reportWebVitals';

import { theme } from "./common/theme/Theme";
import { ThemeProvider } from "@mui/material/styles";
import KeycloakProvider from './providers/KeycloakProvider';

import './index.css';


const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <KeycloakProvider>
      <Router>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>    
      </Router>
    </KeycloakProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
